/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PolicyType {
  VEHICLE_CAP = 'vehicle_cap',
  DISTRIBUTION = 'distribution',
  OPERATOR_DROP_OFFS = 'operator_drop_offs',
  UTILIZATION = 'utilization',
  VEHICLE_FEES = 'vehicle_fees',
  NO_RIDE = 'no_ride',
  SLOW_RIDE = 'slow_ride',
  TRIP_FEES = 'trip_fees',
  PARKING_TIME_LIMIT = 'parking_time_limit',
  NO_PARKING = 'no_parking',
  PREFERRED_PARKING = 'preferred_parking',
  PARKING_FEES = 'parking_fees',
  PARKING = 'parking',
  LOADING = 'loading',
  NO_LOADING = 'no_loading',
  UNLOADING = 'unloading',
  NO_UNLOADING = 'no_unloading',
  STOPPING = 'stopping',
  NO_STOPPING = 'no_stopping',
  TRAVEL = 'travel',
  NO_TRAVEL = 'no_travel',
}
